(function(algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var hits = algolia.externals.widgets.hits;
  var related = algolia.externals.widgets.configureRelatedItems;
  var configure = algolia.externals.widgets.configure;
  var aa = algolia.externals.aa;

  /* Array which will contain all filters to be applied while initiating the search API call. */
  var searchFilters = [];

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /* For 'allow', we don't need to add any filter as we want to continue displaying all out of stock items. */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /* For 'continue' we will filter on `inventory_available` attribute whose value is dependent on: `inventory_quantity > 0 OR inventory_policy == 'continue'` */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  function singleIndex(indexName) {
    return {
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return route;
      },
      routeToState: function(routeState) {
        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  // Main Search
  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    hitsPerPage: 12,
    search: instantsearch({
      searchClient: algoliasearch(algolia.config.app_id,algolia.config.search_api_key),
      indexName: algolia.config.index_prefix + 'products',
      //paginationLimitedTo: 5000,
      routing: false,
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter('filters',searchFilters.join(' AND '));
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: '#product-recommendations-list',
    storeName: algolia.storeName,
    templates: {
      empty: algolia.getTemplate('instant_search_no_result'),
      product: algolia.getTemplate('instant_search_product'),
      style: algolia.compileTemplate('instant_search.css'),
    },
  };

  algolia.instantsearch = instant;

  algolia.appendStyle(
    algolia.render(instant.templates.style, {
      distinct: instant.distinct,
      colors: instant.colors,
    })
  );

  // Bind helpers
  var helpers = algolia.assign({},
    algolia.helpers,
    algolia.translation_helpers
  );
  Object.keys(helpers).forEach(function(name) {
    var helper = helpers[name];
    instant.search.templatesConfig.helpers[name] = helper;
  });
  instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

  instant.$results = document.querySelector(instant.selector);

    // Hits per page
instant.search.addWidgets([
  configure({
    hitsPerPage: instant.hitsPerPage,
    clickAnalytics: true,
    facetingAfterDistinct: true
  }),
]);

  // Product Recommendations
  var thisProduct = $('[data-product-for-recs]').html();
  if(typeof thisProduct == 'undefined'){
    return;
  } else {
    thisProduct = JSON.parse(thisProduct);
  }

  instant.search.addWidgets([
    related({
      hit: thisProduct,
      matchingPatterns: { // customization how recommendations should operate (what to boost and how)
        "metafield.global.contributor": { score: 1 },
        "collections": { score: 1 },
        "tags": { score: 1 },
        "title": {score: 1}
      }
    }),
    hits({
      container: '#product-recommendations-list',
      transformItems: function(products){
        return products.map(function(product) {
          var sellable = product.inventory_management !== 'shopify' || product.inventory_policy === 'continue' || product.variants_inventory_count > 0;
          return algolia.assign({}, product, {
            _distinct: instant.distinct,
            add_to_cart: product.variants_count == 1 && sellable,
            totalProducts: products.length,
            can_order: sellable,
            translations: algolia.translations,
            queryID: product.__queryID,
            productPosition: product.__position,
            index: instant.search.mainIndex.getIndexName(),
            is_ebook_variant: product.options.format == 'eBook',
            ebook: product.tags.indexOf('eBook') !== -1
          });
        });
      },
      templates: { // template for how the Recommendations widget will look
        empty: instant.templates.empty,
        item: instant.templates.product,
        style: instant.templates.style,
      },
    }),
  ]);

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value));
  };

  var arrowRight = '<svg class="icon icon-circle-right" aria-hidden="true" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0c-141.385 0-256 114.615-256 256s114.615 256 256 256 256-114.615 256-256-114.615-256-256-256zM256 464c-114.875 0-208-93.125-208-208s93.125-208 208-208 208 93.125 208 208-93.125 208-208 208z"></path><path fill="currentColor" d="M177.372 353.372l45.256 45.256 142.627-142.628-142.628-142.627-45.254 45.254 97.372 97.373z"></path></svg>';
  var arrowLeft = '<svg class="icon icon-circle-left" aria-hidden="true" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512c141.385 0 256-114.615 256-256s-114.615-256-256-256-256 114.615-256 256 114.615 256 256 256zM256 48c114.875 0 208 93.125 208 208s-93.125 208-208 208-208-93.125-208-208 93.125-208 208-208z"></path><path fill="currentColor" d="M334.628 158.628l-45.256-45.256-142.627 142.628 142.628 142.627 45.254-45.254-97.372-97.373z"></path></svg>';

  // Post render functions
  instant.search.addWidgets([
    {
      render: function(opts) {
        // Update products
        $('.ais-hit.ais-product').each(function(){
          var $thisHit = $(this);
          var handle = $(this).attr('data-handle');
          var id = $(this).attr('data-algolia-objectid');
          var hasColor = false;

          $.getJSON('/products/'+handle+'.js', function(product){
            var variantsArray = product.variants;
            var optionsArray = product.options;

            // Sale Prices
            if(product.price_varies){
              var atLeastOneOnSale = false;

              variants:
              for(var i = 0, allVars = variantsArray.length; i < allVars; i++){
                if(variantsArray[i].compare_at_price > variantsArray[i].price) {
                  atLeastOneOnSale = true;
                  break variants;
                }
              }

              if(atLeastOneOnSale){
                var newPriceHtml = '<b class="ais-hit--price-discount">' + formatPrice(product.price_min) + ' - ' + formatPrice(product.price_max) + ' Sale</b>';
                $thisHit.find('.ais-hit--price').html(newPriceHtml);
              }
            }

            // Swatches
            var swatchesHtml = '';
            optionsLoop:
            for(var i = 0, allOpts = optionsArray.length; i < allOpts; i++){
              if(optionsArray[i].name == 'Color'){
                hasColor = true;
                colorsLoop:
                for(var j = 0; j < optionsArray[i].values.length; j++){
                  var thisColor = optionsArray[i].values[j];
                  var variantImg = '';
                  var swatchImg = '//cdn.shopify.com/s/files/1/0285/2821/4050/files/color-'+thisColor.replace(/\W+/g, "-").toLowerCase()+'.png';
                  variantsLoop:
                  for(var k = 0, allVars = variantsArray.length; k < allVars; k++){
                    if(variantsArray[k].options[i] == thisColor){
                      variantImg = variantsArray[k].featured_image.src;
                      break variantsLoop;
                    }
                  }
                  var selectedClass = (j == 0) ? ' selected':'' ;
                  swatchesHtml += '<button class="ais-hit--swatch ais-color-swatch'+selectedClass+'" style="background-image:url('+swatchImg+')" data-img="'+variantImg.replace(/(\.[^.]*)$/, "_medium$1")+'"></button>';
                }
                break optionsLoop;
              }
            }

            if(hasColor && $('#ais-hit-swatches-'+id).length == 0){
              $thisHit.find('.ais-hit--details').append('<div id="ais-hit-swatches-'+id+'" class="ais-hit--swatches"><div id="ais-hit-swatches-list-'+id+'" class="ais-hit--swatches-list">'+swatchesHtml+'</div></div>');

              $('#ais-hit-swatches-'+id+' .ais-hit--swatch').click(function(){
                $(this).addClass('selected').siblings().removeClass('selected');
                $thisHit.find('.ais-hit--picture').css('background-image','url('+$(this).attr('data-img')+')');
              });

              moreColorsBtn(id);
            }
          });
        });

        $(window).on('resize',function(){
          $('.ais-hit--swatches:not(.expanded)').each(function(){
            var id = $(this).closest('.ais-hit').attr('data-algolia-objectid');
            moreColorsBtn(id);
          });
        });

        function moreColorsBtn(id){
          var swatchesList = document.getElementById('ais-hit-swatches-list-'+id);
          if(typeof swatchesList !== 'undefined'){
            if(swatchesList.clientHeight < swatchesList.scrollHeight && $('#ais-hit-swatches-more-'+id).length == 0){
              $('#ais-hit-swatches-'+id).append('<button id="ais-hit-swatches-more-'+id+'" class="ais-hit-swatches--more">More Colors +</button>');
              $('#ais-hit-swatches-more-'+id).click(function(){
                $(this).remove();
                $('#ais-hit-swatches-list-'+id).css('height','auto');
                $('#ais-hit-swatches-'+id).addClass('expanded');
              });
            } else if(swatchesList.clientHeight >= swatchesList.scrollHeight) {
              $('#ais-hit-swatches-more-'+id).remove();
            }
          }
        }

        // Slick slider
        $('.ais-Hits-list').on('init',function(){
          setTimeout(function(){
            $('.ais-Hits-list').slick('refresh');
          },500);
        });

        $('.ais-Hits-list').slick({
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true,
          nextArrow: '<button class="slick-next" aria-label="Next slide">'+arrowRight+'</button>',
          prevArrow: '<button class="slick-prev" aria-label="Previous slide">'+arrowLeft+'</button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  ]);

  // Product click events
  instant.search.addWidgets([
    {
      init: function() {
        // Add to Cart button click
        $(document).on('click touchstart','.ais-hit--atc-button',function(e){
          var $hit = $(this).closest('.ais-hit');
          var el = e.target;

          if (!$hit) {
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();
          addToCart(el);
        });

        $(document).on('click touchstart','.ais-hit--picture.ais-hit--link',function(e){
          e.preventDefault();

          var $hit = $(this).closest('.ais-hit');
          var el = e.target;

          if (!$hit) {
            return;
          }

          if(el.matches('.ais-hit--atc-button')){
            // Add to Cart
            addToCart(el);
          } else if(el.matches('.ais-hit--options-button')){
            pdpLink($hit);
          } else {
            if(e.type == 'touchstart'){
              // Mobile, show button, do not go to PDP
              $(this).focus();
            } else {
              // Normal click, go to PDP
              pdpLink($hit);
            }
          }
        });

        function pdpLink($hit){
          var productHandle = $hit.attr('data-handle');
          var variant_id = $hit.attr('data-variant-id');
          var distinct = $hit.attr('data-distinct');

          var link = '/products/' + productHandle;
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }
          if (algolia.config.analytics_enabled) {
            if ($hit[0].dataset != null ){
            var clickData = {
              index: $hit[0].dataset.algoliaIndex,
              eventName: 'click',
              queryID: $hit[0].dataset.algoliaQueryid,
              objectIDs: [$hit[0].dataset.algoliaObjectid],
              positions: [Number($hit[0].dataset.algoliaPosition)],
            };
            // Send the click event
            aa.clickedObjectIDsAfterSearch(clickData);
            /**
             * Uncomment the following function call to start storing data in
             * local storage for conversion tracking
             */
            // algolia.saveForConversionTracking(clickData);
            }
            else{
              window.location.href = link;
            }
          }
          window.location.href = link;
        }

        function addToCart(cartButton){
          var $this = cartButton;
          var formId = $this.dataset.formId;
          if (formId) {
            var isEbook = $this.dataset.isEbook;
            if(isEbook == 'true') {
              var thisId = $('#'+formId+' [name="id"]').val();
              $.getJSON('/cart.js', function(cart){
                var hasThisEbook = false;
                for(var i = 0; i < cart.items.length; i++){
                  if(cart.items[i].id == thisId){
                    hasThisEbook = true;
                    break;
                  }
                }
                if(hasThisEbook){
                  alert('This eBook is already in your cart.');
                } else {
                  document.getElementById(formId).submit();
                }
              });
            } else {
              document.getElementById(formId).submit();
            }
          }
        }
      },
    },
  ]);

  instant.search.start();

})(window.algoliaShopify);
